import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry error tracking
 *
 * Environments:
 * - development: Local development, Sentry disabled
 * - test: CI/CD test runs, Sentry disabled
 * - stage: Staging environment, Sentry enabled
 * - production: Production environment, Sentry enabled
 */
const initSentry = () => {
	// Determine Sentry environment
	// - In CI/CD: VITE_ENVIRONMENT is explicitly set to 'production', 'stage', or 'test'
	// - In local dev: VITE_ENVIRONMENT is not set, defaults to 'development'
	const environment = import.meta.env.VITE_ENVIRONMENT || 'development';

	// Disable Sentry for:
	// - Cypress tests (window.Cypress exists)
	// - Vitest tests (MODE === 'test')
	// - Explicit disable flag (VITE_DISABLE_SENTRY)
	// - Local development (environment is 'development')
	const isDisabled =
		(typeof window !== 'undefined' && (window as { Cypress?: unknown }).Cypress) ||
		import.meta.env.MODE === 'test' ||
		import.meta.env.VITE_DISABLE_SENTRY === 'true' ||
		environment === 'development';

	Sentry.init({
		dsn: 'https://11a16d48bb7ee78f1f402704d24e5c9c@o4508811602362368.ingest.de.sentry.io/4509433873432656',
		environment,
		enabled: !isDisabled
	});
};

/**
 * Sentry service for error tracking initialization
 */
export default {
	/**
	 * Initializes Sentry error tracking with environment-specific configuration
	 */
	init: initSentry
};
